<app-buttons-section></app-buttons-section>
<app-inputs-section></app-inputs-section>
<app-crs-section></app-crs-section>
<app-navigation-section></app-navigation-section>
<section class="section section-components">
  <app-tabs-section></app-tabs-section>
  <app-alerts-section></app-alerts-section>
  <app-typography-section></app-typography-section>
  <app-angular-section></app-angular-section>
</section>
<section class="section section-shaped">
  <div class="shape shape-style-1 shape-default">
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </div>
  <div class="container py-md">
    <div class="row justify-content-between align-items-center">
      <div class="col-lg-5 mb-5 mb-lg-0">
        <h1 class="text-white font-weight-light">Bootstrap carousel</h1>
        <p class="lead text-white mt-4">Argon Design System comes with four pre-built pages to help you get started faster. You can change the text and images and you're good to go.</p>
        <a href="https://demos.creative-tim.com/argon-design-system-angular/documentation/alerts?ref=adsa-bootstrap-carousel" class="btn btn-white mt-4">See all components</a>
      </div>
      <div class="col-lg-6 mb-lg-auto">
        <div class="rounded shadow-lg overflow-hidden transform-perspective-right">
          <ngb-carousel>
              <ng-template ngbSlide>
                <img class="img-fluid" src="assets/img/theme/img-1-1200x1000.jpg" alt="First slide">
              </ng-template>
              <ng-template ngbSlide>
                <img class="img-fluid" src="assets/img/theme/img-2-1200x1000.jpg" alt="Second slide">
              </ng-template>
          </ngb-carousel>
        </div>
      </div>
    </div>
  </div>
  <!-- SVG separator -->
  <div class="separator separator-bottom separator-skew">
    <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <polygon class="fill-white" points="2560 0 2560 100 0 100"></polygon>
    </svg>
  </div>
</section>
<app-nucleo-section></app-nucleo-section>
<section class="section section-lg section-shaped">
  <div class="shape shape-style-1 shape-default">
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </div>
  <div class="container py-md">
    <div class="row row-grid justify-content-between align-items-center">
      <div class="col-lg-6">
        <h3 class="display-3 text-white">A beautiful Design System
          <span class="text-white">completed with examples</span>
        </h3>
        <p class="lead text-white">The Design System comes with four pre-built pages to help you get started faster. You can change the text and images and you're good to go. More importantly, looking at them will give you a picture of what you can built with this powerful Bootstrap 4 Design System.</p>
        <div class="btn-wrapper">
          <a [routerLink]="['/login']" class="btn btn-success">Login Page</a>
          <a [routerLink]="['/register']" class="btn btn-white">Register Page</a>
        </div>
      </div>
      <div class="col-lg-5 mb-lg-auto">
        <div class="transform-perspective-right">
          <div class="card bg-secondary shadow border-0">
            <div class="card-header bg-white pb-5">
              <div class="text-muted text-center mb-3">
                <small>Sign in with</small>
              </div>
              <div class="btn-wrapper text-center">
                <a href="javascript:void(0)" class="btn btn-neutral btn-icon">
                  <span class="btn-inner--icon">
                    <img src="./assets/img/icons/common/github.svg">
                  </span>
                  <span class="btn-inner--text">Github</span>
                </a>
                <a href="javascript:void(0)" class="btn btn-neutral btn-icon">
                  <span class="btn-inner--icon">
                    <img src="./assets/img/icons/common/google.svg">
                  </span>
                  <span class="btn-inner--text">Google</span>
                </a>
              </div>
            </div>
            <div class="card-body px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <small>Or sign in with credentials</small>
              </div>
              <form role="form">
                <div class="form-group mb-3" [ngClass]="{'focused':focus===true}">
                  <div class="input-group input-group-alternative">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="ni ni-email-83"></i></span>
                    </div>
                    <input class="form-control" placeholder="Email" type="email" (focus)="focus=true" (blur)="focus=false">
                  </div>
                </div>
                <div class="form-group" [ngClass]="{'focused':focus1===true}">
                  <div class="input-group input-group-alternative">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="ni ni-lock-circle-open"></i></span>
                    </div>
                    <input class="form-control" placeholder="Password" type="password" (focus)="focus1=true" (blur)="focus1=false">
                  </div>
                </div>
                <div class="custom-control custom-control-alternative custom-checkbox">
                  <input class="custom-control-input" id=" customCheckLogin2" type="checkbox">
                  <label class="custom-control-label" for=" customCheckLogin2">
                    <span>Remember me</span>
                  </label>
                </div>
                <div class="text-center">
                  <button type="button" class="btn btn-primary my-4">Sign in</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- SVG separator -->
  <div class="separator separator-bottom separator-skew">
    <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <polygon class="fill-white" points="2560 0 2560 100 0 100"></polygon>
    </svg>
  </div>
</section>
<app-versions-section></app-versions-section>
